import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-2 d-print-none" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-12" }
const _hoisted_5 = { class: "row mb-2" }
const _hoisted_6 = { class: "col-md-2 col-6" }
const _hoisted_7 = { class: "col-md-2 col-6" }
const _hoisted_8 = { class: "col-md-2 col-6" }
const _hoisted_9 = { class: "col-md-2 col-6" }
const _hoisted_10 = { class: "col-md-2 col-6" }
const _hoisted_11 = { class: "col-md-12" }
const _hoisted_12 = {
  key: 0,
  class: "col-md-12 text-center"
}
const _hoisted_13 = { class: "p-4" }
const _hoisted_14 = { class: "fw-14 text-danger" }
const _hoisted_15 = {
  key: 1,
  class: "col-md-12 text-center"
}
const _hoisted_16 = {
  class: "tabela table-sm table-bordered f12px",
  id: "tabela-relatorio"
}
const _hoisted_17 = { class: "table-relatorio" }
const _hoisted_18 = { class: "text-start text-truncate colNome" }
const _hoisted_19 = { class: "text-end" }
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = { class: "text-end" }
const _hoisted_22 = { class: "text-end" }
const _hoisted_23 = { class: "text-end" }
const _hoisted_24 = { class: "text-center" }
const _hoisted_25 = { class: "text-center" }
const _hoisted_26 = { class: "border-top" }
const _hoisted_27 = { class: "text-end fw-bold" }
const _hoisted_28 = { class: "text-end fw-bold" }
const _hoisted_29 = { class: "text-end fw-bold" }

import { onMounted, reactive, computed } from "vue";
import { useRoute } from 'vue-router';

//servicos
import config from "@/app.config.json";
import * as service from "@/services/relatoriosService";
import { fdata, f2dec, fdataUS } from "@/utils/funcoes";
import { useOrdenacao } from "@/composables/useOrdenacao";

//componentes
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import TextBox from "@/components/TextBox/Index.vue";
import TrataTecla from "@/components/TrataTecla/Index.vue";
import Notificacao from "@/components/Notificacao/Index.vue";
import AutoCompleteCidade from "@/components/AutoCompletes/AutoCompleteCidade.vue";
import DropdownCidadesAtiva from "@/components/Dropdowns/DropdownCidadesAtiva.vue";
import ReportView from "@/components/ReportView/Index.vue";
import ReportCabecalho from "@/components/ReportView/Cabecalho.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Mensalidades',
  setup(__props) {


//vue
const route = useRoute();

var controle = reactive({

  filtros: {
    dataVencInicial: fdataUS(new Date(new Date().setDate(new Date().getDate() - 30))),
    dataVencFinal: fdataUS(new Date()),
    status: "Recebido",
  } as unknown as service.FiltroMensalidades,
  cidadeId: null as number | null,
  cidadeNome: "" as string,
  itens: [] as service.RelMensDTO[],

  totalRegistros: 0,

  qtdeRegistros: 0,
  qtdePagos: 0,
  qtdeEmAberto: 0,
  qtdeVencidos: 0,

  totalGeral: 0,
  totalPago: 0,
  totalEmAberto: 0,
  totalVencido: 0,
  totalAcresDesc: 0,

  erro: "",
  status: "",
  pesquisando: false,
})


function selecionouCidade(cidade: any) {
  controle.cidadeNome = cidade ? `${cidade.nome} - ${cidade.estado}` : "";
}

const resumoFiltros = computed(() => {
  const statusLabel = controle.filtros.status === "Recebido" ? "Recebido"
    : controle.filtros.status === "A Receber" ? "Em Aberto"
    : "Todos";
  const partes = [
    `Vencto: ${fdata(controle.filtros.dataVencInicial)} a ${fdata(controle.filtros.dataVencFinal)}`,
    `Cidade: ${controle.cidadeId ? controle.cidadeNome : "Todas"}`,
    `Status: ${statusLabel}`,
  ];
  return partes.join("  |  ");
});

async function pesquisar() {

  if (controle.cidadeId != null && controle.cidadeId > 0) {
    controle.filtros.cidadesIds = [controle.cidadeId];
  } else {
    controle.filtros.cidadesIds = null;
  }

  service.mensalidades(controle.filtros)
    .then(r => {
      controle.itens = r.dados;

      controle.totalRegistros = r.totalRegistros;
      controle.pesquisando = false;

      controle.qtdeRegistros = controle.itens.length;
      controle.qtdeEmAberto = 0;
      controle.qtdePagos = 0;
      controle.qtdeVencidos = 0;

      controle.totalGeral = 0;
      controle.totalEmAberto = 0;
      controle.totalPago = 0;
      controle.totalVencido = 0;
      controle.totalAcresDesc = 0;

      controle.itens.forEach(a => {

        controle.totalGeral += a.valor;
        
        if (a.dataPagamento != null) {
          controle.qtdePagos += 1;
          controle.totalPago += a.valorPago;
          controle.totalAcresDesc += a.valorPago - a.valor;
        } 

      });

    })
    .catch(erro => {
      controle.erro = erro;
      controle.pesquisando = false;
    })
}

const sort = useOrdenacao("dataPagamento");

const itensOrdenados = computed(() => sort.aplicar(controle.itens, {
  nome: (item: service.RelMensDTO) => item.clienteNome || "",
  cliente: (item: service.RelMensDTO) => item.clienteId ?? -1,
  parcela: (item: service.RelMensDTO) => item.parcela ?? -1,
  valor: (item: service.RelMensDTO) => item.valor ?? 0,
  valorPago: (item: service.RelMensDTO) => item.valorPago ?? 0,
  acresDesc: (item: service.RelMensDTO) => (item.valorPago > 0 ? item.valorPago - item.valor : 0),
  dataVencimento: (item: service.RelMensDTO) => item.dataVencimento || "",
  dataPagamento: (item: service.RelMensDTO) => item.dataPagamento || "",
}));


return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BreadCrumb, {
      PageTitle: "Relatório de Mensalidades",
      items: [
    { label: 'Relatorios', to: '/relatorios' },
    { label: 'Mensalidades', to: '/relatorios/mensalidades' }]
    }),
    _createVNode(Notificacao, {
      erro: _unref(controle).erro,
      onLimparErro: _cache[0] || (_cache[0] = ($event: any) => (_unref(controle).erro = '')),
      progresso: _unref(controle).status,
      onLimparProgresso: _cache[1] || (_cache[1] = ($event: any) => (_unref(controle).status = ''))
    }, null, 8, ["erro", "progresso"]),
    _createVNode(TrataTecla, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _cache[14] || (_cache[14] = _createElementVNode("label", null, "Vencto Inicial", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(controle).filtros.dataVencInicial) = $event)),
                      class: "form-control form-control-sm",
                      id: "dataVencInicial",
                      type: 'date'
                    }, null, 512), [
                      [_vModelDynamic, _unref(controle).filtros.dataVencInicial]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _cache[15] || (_cache[15] = _createElementVNode("label", null, "Vencto Final", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(controle).filtros.dataVencFinal) = $event)),
                      class: "form-control form-control-sm",
                      id: "dataVencFinal",
                      type: 'date'
                    }, null, 512), [
                      [_vModelDynamic, _unref(controle).filtros.dataVencFinal]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _cache[16] || (_cache[16] = _createElementVNode("label", null, "Cidade", -1)),
                    _createVNode(DropdownCidadesAtiva, {
                      modelValue: _unref(controle).cidadeId,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(controle).cidadeId) = $event)),
                      id: "cidadeId",
                      onSelected: selecionouCidade
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _cache[18] || (_cache[18] = _createElementVNode("label", null, "Status", -1)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(controle).filtros.status) = $event)),
                      class: "form-select form-select-sm",
                      id: "status"
                    }, [...(_cache[17] || (_cache[17] = [
                      _createElementVNode("option", { value: "" }, "Todos", -1),
                      _createElementVNode("option", { value: 'Recebido' }, "Recebido", -1),
                      _createElementVNode("option", { value: 'A Receber' }, "Em Aberto", -1)
                    ]))], 512), [
                      [_vModelSelect, _unref(controle).filtros.status]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("a", {
                      class: "btn btn-primary btn-sm mt-4",
                      onClick: pesquisar
                    }, "Pesquisar"),
                    _createVNode(_component_RouterLink, {
                      class: "btn btn-sm btn-secondary float-end mt-4",
                      to: '/parceiros'
                    }, {
                      default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                        _createTextVNode("Fechar", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(ReportView, {
            titulo: 'Rel Mensalidades',
            btnImprimir: true
          }, {
            default: _withCtx(() => [
              (_unref(controle).erro != '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(controle).erro), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_unref(controle).erro == '' && _unref(controle).pesquisando == true)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [...(_cache[20] || (_cache[20] = [
                    _createElementVNode("div", { class: "p-4" }, [
                      _createElementVNode("i", { class: "fa fa-cog fa-2x fa-spin" }),
                      _createElementVNode("div", { class: "fw-16" }, "Pesquisando...")
                    ], -1)
                  ]))]))
                : _createCommentVNode("", true),
              (_unref(controle).erro == '' && _unref(controle).pesquisando == false)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createVNode(ReportCabecalho, {
                      Titulo: 'Relatório de Mensalidades',
                      Filtros: resumoFiltros.value
                    }, null, 8, ["Filtros"]),
                    _createElementVNode("table", _hoisted_16, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", _hoisted_17, [
                          _createElementVNode("th", {
                            class: "text-start text-truncate colNome col-ordenavel",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(sort).alternar('nome')))
                          }, [
                            _cache[21] || (_cache[21] = _createTextVNode("Nome ", -1)),
                            _createElementVNode("i", {
                              class: _normalizeClass(_unref(sort).classeIcone('nome'))
                            }, null, 2)
                          ]),
                          _createElementVNode("th", {
                            class: "text-end col-ordenavel",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(sort).alternar('cliente')))
                          }, [
                            _cache[22] || (_cache[22] = _createTextVNode("Cliente ", -1)),
                            _createElementVNode("i", {
                              class: _normalizeClass(_unref(sort).classeIcone('cliente'))
                            }, null, 2)
                          ]),
                          _createElementVNode("th", {
                            class: "text-center col-ordenavel",
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(sort).alternar('parcela')))
                          }, [
                            _cache[23] || (_cache[23] = _createTextVNode("Parcela ", -1)),
                            _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1)),
                            _cache[25] || (_cache[25] = _createTextVNode(" Contrato ", -1)),
                            _createElementVNode("i", {
                              class: _normalizeClass(_unref(sort).classeIcone('parcela'))
                            }, null, 2)
                          ]),
                          _createElementVNode("th", {
                            class: "text-end col-ordenavel",
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (_unref(sort).alternar('valor')))
                          }, [
                            _cache[26] || (_cache[26] = _createTextVNode("Valor R$ ", -1)),
                            _createElementVNode("i", {
                              class: _normalizeClass(_unref(sort).classeIcone('valor'))
                            }, null, 2)
                          ]),
                          _createElementVNode("th", {
                            class: "text-end col-ordenavel",
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (_unref(sort).alternar('valorPago')))
                          }, [
                            _cache[27] || (_cache[27] = _createTextVNode("Pago R$ ", -1)),
                            _createElementVNode("i", {
                              class: _normalizeClass(_unref(sort).classeIcone('valorPago'))
                            }, null, 2)
                          ]),
                          _createElementVNode("th", {
                            class: "text-end col-ordenavel",
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (_unref(sort).alternar('acresDesc')))
                          }, [
                            _cache[28] || (_cache[28] = _createTextVNode("Acres", -1)),
                            _cache[29] || (_cache[29] = _createElementVNode("br", null, null, -1)),
                            _cache[30] || (_cache[30] = _createTextVNode("Desc R$ ", -1)),
                            _createElementVNode("i", {
                              class: _normalizeClass(_unref(sort).classeIcone('acresDesc'))
                            }, null, 2)
                          ]),
                          _createElementVNode("th", {
                            class: "text-center col-ordenavel",
                            onClick: _cache[12] || (_cache[12] = ($event: any) => (_unref(sort).alternar('dataVencimento')))
                          }, [
                            _cache[31] || (_cache[31] = _createTextVNode("Vencimento ", -1)),
                            _createElementVNode("i", {
                              class: _normalizeClass(_unref(sort).classeIcone('dataVencimento'))
                            }, null, 2)
                          ]),
                          _createElementVNode("th", {
                            class: "text-center col-ordenavel",
                            onClick: _cache[13] || (_cache[13] = ($event: any) => (_unref(sort).alternar('dataPagamento')))
                          }, [
                            _cache[32] || (_cache[32] = _createTextVNode("Pagamento ", -1)),
                            _createElementVNode("i", {
                              class: _normalizeClass(_unref(sort).classeIcone('dataPagamento'))
                            }, null, 2)
                          ])
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itensOrdenados.value, (item, idx) => {
                          return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                            _createElementVNode("td", _hoisted_18, _toDisplayString(item.clienteNome), 1),
                            _createElementVNode("td", _hoisted_19, _toDisplayString(item.clienteId), 1),
                            _createElementVNode("td", _hoisted_20, _toDisplayString(item.parcela) + " / " + _toDisplayString(item.contratoId), 1),
                            _createElementVNode("td", _hoisted_21, _toDisplayString(_unref(f2dec)(item.valor)), 1),
                            _createElementVNode("td", _hoisted_22, _toDisplayString(_unref(f2dec)(item.valorPago)), 1),
                            _createElementVNode("td", _hoisted_23, _toDisplayString(_unref(f2dec)(item.valorPago > 0 ? item.valorPago - item.valor : 0)), 1),
                            _createElementVNode("td", _hoisted_24, _toDisplayString(_unref(fdata)(item.dataVencimento)), 1),
                            _createElementVNode("td", _hoisted_25, _toDisplayString(_unref(fdata)(item.dataPagamento)), 1)
                          ]))
                        }), 128)),
                        _createElementVNode("tr", _hoisted_26, [
                          _cache[33] || (_cache[33] = _createElementVNode("td", null, null, -1)),
                          _cache[34] || (_cache[34] = _createElementVNode("td", null, null, -1)),
                          _cache[35] || (_cache[35] = _createElementVNode("td", null, null, -1)),
                          _createElementVNode("td", _hoisted_27, _toDisplayString(_unref(f2dec)(_unref(controle).totalGeral)), 1),
                          _createElementVNode("td", _hoisted_28, _toDisplayString(_unref(f2dec)(_unref(controle).totalPago)), 1),
                          _createElementVNode("td", _hoisted_29, _toDisplayString(_unref(f2dec)(_unref(controle).totalAcresDesc)), 1),
                          _cache[36] || (_cache[36] = _createElementVNode("td", null, null, -1)),
                          _cache[37] || (_cache[37] = _createElementVNode("td", null, null, -1))
                        ])
                      ])
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})